module.exports = __webpack_public_path__ + "static/media/story-11.5b44e7a3.jpg";